module.exports = __webpack_public_path__ + "img/main-right-bottom.fc608f01.png";